import { Reducer } from 'redux';
import { IJewishnessFilesDetails, IJewishnessState } from 'types/jewishness.types';
import * as authConstants from '../constants/auth.constants';
import * as constants from '../constants/jewishness.constants';

export const defaultState: IJewishnessState = {
  cementeries: {},
  civilStates: {},
  count: 0,
  idCardTypes: {},
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'id',
    sortType: 'asc',
  },
  tribes: {},
};

const jewishnessReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.JEWISHNESS_ON_DELETE_REQUESTED:
    case constants.JEWISHNESS_ON_DELETE_FILE_REQUESTED:
    case constants.JEWISHNESS_ON_GET_ALL_REQUESTED:
    case constants.JEWISHNESS_ON_GET_FORM_REQUESTED:
    case constants.JEWISHNESS_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.JEWISHNESS_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.JEWISHNESS_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.JEWISHNESS_ON_GET_FORM_SUCCEEDED:
      return {
        ...state,
        cementeries: data.cementeries,
        civilStates: data.civilStates,
        idCardTypes: data.idCardTypes,
        loading: false,
        tribes: data.tribes,
      };
    case constants.JEWISHNESS_ON_DELETE_FILE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: {
          ...state.selectedItem,
          files: state.selectedItem.files.filter(
            (file: IJewishnessFilesDetails) => file.id.toString() !== data.fileId,
          ),
        },
      };
    case constants.JEWISHNESS_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.JEWISHNESS_ON_DELETE_SUCCEEDED:
    case constants.JEWISHNESS_ON_SAVE_SUCCEEDED:
    case constants.JEWISHNESS_ON_DELETE_FAILED:
    case constants.JEWISHNESS_ON_DELETE_FILE_FAILED:
    case constants.JEWISHNESS_ON_GET_ALL_FAILED:
    case constants.JEWISHNESS_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.JEWISHNESS_ON_GET_FORM_FAILED:
      return {
        ...state,
        cementeries: {},
        civilStates: {},
        idCardTypes: {},
        loading: false,
        tribes: {},
      };
    case constants.JEWISHNESS_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default jewishnessReducer;
